import React from 'react';
import classnames from 'classnames';
import styles from './organization-card.module.scss';
import { Props as CardProps } from '../generic/card';
import { RectangularCard } from '../generic';

interface Props extends CardProps {
    name?: string;
}

const OrganizationCategoryCard: React.FC<Props> = ({
    name,
    onClick,
    className,
    children,
}: Props) => (
    <RectangularCard
        className={classnames(styles.OrganizationCard, className)}
        onClick={onClick}
    >
        {children}
        {!children && name && <div className={styles.title}>{name}</div>}
    </RectangularCard>
);

export default OrganizationCategoryCard;
